// Wrapper for pickadate

class DatePicker {
	constructor(el, customConfig = null) {
		this.el = el || $('<input></input>');

		this.format = 'yyyy mmm dd';
		if (window.DATE_FORMAT === '0') {
			this.format = 'mmm dd yyyy';
		} else if (window.DATE_FORMAT === '1') {
			this.format = 'dd mmm yyyy';
		} else if (window.DATE_FORMAT === '2') {
			this.format = 'yyyy mmm dd';
		}

		if (el.val instanceof Function && this.el.val()) {
			// http://amsul.ca/pickadate.js/date/#formats_prefill
			const jsDate = new Date(this.el.val());
			const day = jsDate.getDate();
			const month = jsDate.getMonth() + 1;
			const year = jsDate.getFullYear();
			const formattedDate = `${month <= 9 ? `0${month}` : month}`
				+ `/${day <= 9 ? `0${day}` : day}`
				+ `/${year}`;
			this.el.data('value', formattedDate);
		}

		const config = {
			selectYears: 200,
			selectMonths: true,
			format: this.format,
			formatSubmit: 'mm/dd/yyyy',
			hiddenName: true,
			klass: {
				selectMonth: 'picker__select--month',
				selectYear: 'picker__select--year',
			},
		};

		if (customConfig !== null) {
			_.extend(config, customConfig);
		}

		this.picker = $(this.el)
			.pickadate(config)
			.pickadate('picker');
	}

	get() {
		return this.picker.get('select', 'yyyy/mm/dd');
	}
}

module.exports = DatePicker;



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.admin/components/datepicker.js